import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { FilterBar } from './FilterNav.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import { CheckBox, CheckboxIcon, DateContainer, ExportContent, ExportDropDown, FilterBox, FilterButton, FilterButtons, FilterDrop, FilterDropHead, FilterDropInput, FilterInfo, FilterInput, FilterItem, FilterReset, FilterText, GapScroll, QuickBtn, FilterContainer } from '../SchoolLeader.styled';
import Tooltip from '@components/Tooltips/Tooltip';
import { DateSelector, SubTitle } from '../StudentDetails/StudentDetails.styled';
import DateSelect from '../StudentDetails/DateSelect';
import Tooltip_Icon from "@assets/svg/new_exclam1.svg";
import Cal_Icon from "@assets/svg/new_calendar.svg"
import { Tag, Tags } from '../RegistrationDetails/RegistrationDetails.styled';
import PDF_Icon from "@assets/svg/new_pdf.svg"
import Excel_Icon from "@assets/svg/excel.svg"
import Chevron_Icon from "@assets/svg/chevron-down.svg"
import Toggle from '@components/Buttons/Toggle';
import Check_Icon from "@assets/svg/match/attending.svg"

interface IProps {
  filterSelected: boolean;
  exportExcel?: () => void;
}

export const SubNav = (props: IProps) => {
  const { setPage, setActiveFilter, activeFilter, dateFilter, setDateFilter, schoolViewFilter, setSchoolViewFilter, filterDate, schoolViewRegistrations, callNameSetting, schoolViewTags, schoolLeaderView, schoolViewDateRange, setSchoolViewDateRange, selectedSchoolViewSearch, client, settings } = useStore();
  const i18n = useI18n();
  const [types, setTypes] = useState([])
  const [courses, setCourses] = useState([])
  const [subjects, setSubjects] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const [subjectFilter, setSubjectFilter] = useState('')
  const [courseList, setCourseList] = useState([])
  const [courseFilter, setCourseFilter] = useState('')
  const [fromDate, setFromDate] = useState(new Date())
  const [quickFilter, setQuickFilter] = useState(null)
  const [toDate, setToDate] = useState(new Date())
  const [filterText, setFilterText] = useState(null)
  const [filterWorst, setFilterWorst] = useState(null)
  const [filterBest, setFilterBest] = useState(null)
  const [filterOpen, setFilterOpen] = useState(null)
  const [active, setActive] = useState(schoolViewFilter.active)
  const [inactive, setInActive] = useState(schoolViewFilter.inactive)
  const inputRef = useRef(null)
  const [selectedTags, setSelectedTags] = useState([])

  useEffect(() => {
    if (props.filterSelected) getCoursesDB()
    if (props.filterSelected) getSubjectDB()
  }, [props.filterSelected])

  const clearFilter = (type, value) => {
    switch (type) {
      case 0:
        handleFilter(type, value)
        break;
      case 1:
        setFilterText('')
        handleFilter(type, value)
        break;
      case 2:
        setCourses([])
        setSubjects([])
        handleFilter(type, value)
        break;
      case 3:
        setFromDate(schoolLeaderView === 0 ? moment().toDate() : moment(filterDate.from).toDate())
        setToDate(moment().toDate())
        setQuickFilter(schoolLeaderView === 0 ? 0 : 5)
        handleFilter(type, schoolLeaderView === 0 ? moment().toDate() : moment(filterDate.from).toDate(), moment().toDate(), schoolLeaderView === 0 ? 0 : 5)
        break;
      case 4:
        setTypes([])
        handleFilter(type, value)
        break;
      case 5:
        handleFilter(type, true, true)
        break;
      case 6:
        setSelectedTags([])
        handleFilter(type, [])
        break;
      case 7:
        handleFilter(type, 30, 3)
        setQuickFilter(3)
        break;
      case 8:
        handleFilter(type, [])
        setSubjects([])        
        break;
      case 10:
        setFilterWorst('')
        handleFilter(type, value)
        break;
      case 11:
        setFilterBest('')
        handleFilter(type, value)
        break;
    }
  }

  const handleInput = (type, value) => {
    switch (type) {
      case 1:
        let n = Number(value)
        if (n > 100) n = 100
        if (n < 0) n = 0
        setFilterText(n > 0 ? n : "")
        break;
      case 2:
        let c = JSON.parse(JSON.stringify(courses))
        if (value === -1) c = []
        else if (c.includes(value)) c = c.filter(v => v !== value)
        else (c.push(value))
        setCourses(c)
        break;
      case 3:
        let s = JSON.parse(JSON.stringify(subjects))
        if (value === -1) s = []
        else if (s.includes(value)) s = s.filter(v => v !== value)
        else (s.push(value))
        setSubjects(s)
        break;
      case 4:
        let t = JSON.parse(JSON.stringify(types))
        if (value === -1) t = []
        else if (t.includes(value)) t = t.filter(v => v !== value)
        else t.push(value)
        if (t.length === 3) t = []
        setTypes(t)
        break;
      case 5:
        setActive(!value)
        break;
      case 6:
        setInActive(!value)
        break;
      case 10:
        let nw = Number(value)
        if (nw > 100) nw = 100
        if (nw < 0) nw = 0
        setFilterWorst(nw > 0 ? nw : "")
        break;
      case 11:
        let nb = Number(value)
        if (nb > 100) nb = 100
        if (nb < 0) nb = 0
        setFilterBest(nb > 0 ? nb : "")
        break;
      default:
        break;
    }
  }

  const saveFilter = async (filterId, value, json?) => {
    await db.SetFilter4User(client.UserName, filterId, json ? JSON.stringify(value) : value.toString())
  }


  const handleFilter = async (type, value, value2?, value3?) => {
    console.log(value, value2, value3)
    

    let f = JSON.parse(JSON.stringify(schoolViewFilter))
    let id = -1
    switch (type) {
      case 0:
        f["search" + schoolLeaderView] = value
        break;
      case 1:
        f["percentage" + schoolLeaderView] = Number(value)
        id = schoolLeaderView === 1 ? 1 : schoolLeaderView === 2 ? 2 : 3
        await saveFilter(id, value)
        break;
      case 2:
        id = schoolLeaderView === 1 ? 4 : 5
        await saveFilter(id, value)
        f["courses" + schoolLeaderView] = value
        id = schoolLeaderView === 1 ? 13 : 14        
        f["subjects" + schoolLeaderView] = []
        await saveFilter(id, [])
        break;
      case 3:
        id = schoolLeaderView === 0 ? 6 : schoolLeaderView === 3 ? 7 : 8
        await saveFilter(id, { toDate: moment(value2).format('YYYY-MM-DD'), fromDate: moment(value).format('YYYY-MM-DD'), quickFilter: value3 }, true)
        f["toDate" + schoolLeaderView] = value2
        f["fromDate" + schoolLeaderView] = value
        if(schoolLeaderView === 0) {          
          setSchoolViewDateRange({ toDate0: value2, fromDate0: value })
        }
        f["quickfilter" + schoolLeaderView] = value3
        break;
      case 4:
        await saveFilter(9, value)
        f.types = value
        break;
      case 5:
        if (value && value2) await saveFilter(10, '')
        else await saveFilter(10, { active: value, inactive: value2 }, true)
        f.active = value
        f.inactive = value2
        break;
      case 6:
        await saveFilter(11, value)
        f.tags = value
        break;
      case 7:
        await saveFilter(12, { quickdays: value, quickFilter: value2 }, true)
        f.quickfilter3 = value2
        f.quickdays = value
        setFilterOpen(null)
        break;
      case 8:
        id = schoolLeaderView === 1 ? 13 : 14
        await saveFilter(id, value)
        f["subjects" + schoolLeaderView] = value
        break;
      case 9:
        id = 15
        await saveFilter(id, !f.advanced)
        f.advanced = !f.advanced
        break;
      case 10:
        f["percentage_worst" + schoolLeaderView] = Number(value)
        id = schoolLeaderView === 1 ? 1 : schoolLeaderView === 2 ? 2 : 3
        await saveFilter(id, value)
        break;
      case 11:
        f["percentage_best" + schoolLeaderView] = Number(value)
        id = schoolLeaderView === 1 ? 1 : schoolLeaderView === 2 ? 2 : 3
        await saveFilter(id, value)
        break;
    }
    setPage(1)
    setSchoolViewFilter(f)
  }

  const handleApply = (type, q?) => {

    console.log(q, fromDate, toDate, moment().toDate())

    switch (type) {
      case 1:
        handleFilter(1, filterText)
        break;
      case 2:
        handleFilter(2, courses)
        setSubjects([])
        break;
      case 3:
        handleFilter(3, fromDate ? fromDate : moment().toDate(), toDate ? toDate : moment().toDate(), q ? q : quickFilter)
        break;
      case 4:
        handleFilter(4, types)
        break;
      case 5:
        handleFilter(5, active, inactive)
        break;
      case 6:
        handleFilter(6, selectedTags)
        break;
      case 8:
        handleFilter(8, subjects)
        break;
      case 9:
        handleFilter(9, null)
        break;
      case 10:
        handleFilter(10, filterWorst)
        break;
      case 11:
        handleFilter(11, filterBest)
        break;
      default:
        break;
    }

    setFilterOpen(null)
  }

  const getTypeFilterText = () => {
    if (schoolViewFilter.types.length === 0) return i18n.t("all")
    else if (schoolViewFilter.types.length === 1) {
      switch (schoolViewFilter.types[0]) {
        case 1:
          return i18n.t('registration-type-present')
        case 2:
          return i18n.t('registration-type-absence')
        case 3:
          return i18n.t('registration-type-late')
      }
    }
    else return schoolViewFilter.types.length + " " + i18n.t("selected")
  }

  const handleDateQuickFilter = (type, type2) => {
    let fromdate = moment().toDate()
    let todate = moment().toDate()
    switch (type) {
      case 1:
        fromdate = moment().add(-1, 'day').toDate()
        todate = moment().add(-1, 'day').toDate()
        break;
      case 2:
        fromdate = moment().add(-7, 'day').toDate()
        todate = moment().toDate()
        break;
      case 3:
        fromdate = moment().add(-14, 'day').toDate()
        todate = moment().toDate()
        break;
      case 4:
        fromdate = moment().add(-30, 'day').toDate()
        todate = moment().toDate()
        break;
      case 5:
        fromdate = moment(filterDate.from).toDate()
        todate = moment().toDate()
        break;
    }

    setFromDate(fromdate)
    setToDate(todate)

    handleFilter(type2, fromdate, todate, type)
    setFilterOpen(null)
  }

  const handleDate = (type, value) => {
    let date = moment(value)
    let fDate = moment(fromDate)
    let tDate = moment(toDate)
    setQuickFilter(null)
    switch (type) {
      case 1:
        setFromDate(value)
        if (tDate.isBefore(date)) setToDate(value)
        break;
      case 2:
        setToDate(value)
        if (fDate.isAfter(date)) setFromDate(value)
        break;
    }
  }
  const getDateFilterText = () => {
    if (schoolViewFilter["fromDate" + schoolLeaderView] !== null) {
      switch (schoolViewFilter["quickfilter" + schoolLeaderView]) {
        case 0:
          return i18n.t("dash-select1")
        case 1:
          return i18n.t("filter-date-quickfilter-1")
        case 2:
          return i18n.t("filter-date-quickfilter-2")
        case 3:
          return i18n.t("filter-date-quickfilter-3")
        case 4:
          return i18n.t("filter-date-quickfilter-4")
        case 5:
          return i18n.t("filter-date-quickfilter-5")
        default:
          return i18n.t("filter-date-quickfilter-custom")
      }
    }
    else {
      return i18n.t(schoolLeaderView === 0 ? "dash-select1" : "filter-date-quickfilter-5")
    }
  }

  const getDayFilterText = () => {
    switch (schoolViewFilter["quickfilter" + schoolLeaderView]) {
      case 0:
        return i18n.t("filter-days-quickfilter-0")
      case 1:
        return i18n.t("filter-days-quickfilter-1", { count: 7 })
      case 2:
        return i18n.t("filter-days-quickfilter-1", { count: 14 })
      case 3:
        return i18n.t("filter-days-quickfilter-1", { count: 30 })
      case -1:
        return i18n.t("filter-date-quickfilter-custom")
      default:
        return i18n.t("filter-days-quickfilter-0")
    }
  }

  const getCourseFilterText = (type?) => {
    if (schoolViewFilter["courses" + schoolLeaderView].length === 0) return i18n.t('all')
    else if (schoolViewFilter["courses" + schoolLeaderView].length === 1) {
      return getCourses(schoolViewFilter["courses" + schoolLeaderView][0])
    }
    else {
      return schoolViewFilter["courses" + schoolLeaderView].length + " " + i18n.t("selected")
    }
  }

  const getCoursesDB = async () => {
    setTypes(schoolViewFilter.types)
    setActive(schoolViewFilter.active)
    setInActive(schoolViewFilter.inactive)
    setSelectedTags(schoolViewFilter.tags)
    let courses = await db.GetCourseList(filterDate.from, filterDate.to);
    let temp = courses.map(c => { return { course_id: c.course_sis_id, course_name: c.course_description } });
    setCourseList(temp);
  }

  const getCourses = (course_id?) => {
    if (course_id) {
      let course = courseList.find(c => c.course_id === course_id)
      if (course) return course.course_name
      else return ""
    }
    else return courseList
  }

  const getSubjectFilterText = (type?) => {
    if (schoolViewFilter["subjects" + schoolLeaderView].length === 0) return i18n.t('all')
    else if (schoolViewFilter["subjects" + schoolLeaderView].length === 1) {
      return getSubject(schoolViewFilter["subjects" + schoolLeaderView][0].split(",")[1])
    }
    else {
      return schoolViewFilter["subjects" + schoolLeaderView].length + " " + i18n.t("selected")
    }
  }

  const getSubjectDB = async () => {
    setTypes(schoolViewFilter.types)
    setActive(schoolViewFilter.active)
    setInActive(schoolViewFilter.inactive)
    setSelectedTags(schoolViewFilter.tags)
    try {
     let subject = await db.GetSubjectList(filterDate.from, filterDate.to);    
    let temp = subject?.map(s => { return { course_id: s.course_sis_id, subject_name: s.subject_description } });
    setSubjectList(temp); 
    } catch (error) {
      
    }    
  }

  const getSubject = (subject_id?) => {
    if (subject_id) {
      let subject = subjectList.find(s => s.subject_name === subject_id)
      if (subject) return subject.subject_name
      else return ""
    }
    else {
      return subjectList.filter(s => courses.includes(s.course_id) || courses.length === 0)
    }
  }

  const getActiveFilterText = () => {
    if (schoolViewFilter.active && schoolViewFilter.inactive) return i18n.t("all")
    else if (schoolViewFilter.active && !schoolViewFilter.inactive) return i18n.t("active")
    else if (!schoolViewFilter.active && schoolViewFilter.inactive) return i18n.t("reward-inactive")
  }

  const handleTags = (tag) => {
    let t = JSON.parse(JSON.stringify(selectedTags))
    if (t.includes(tag)) t = t.filter(t => t !== tag)
    else t.push(tag)
    setSelectedTags(t)
  }

  const showFilter = (type) => {
    switch (type) {
      case 1:
        inputRef.current?.blur()
        setFilterOpen(filterOpen === 1 ? null : 1)
        if (filterOpen !== 1) handleInput(1, schoolViewFilter["percentage" + schoolLeaderView])
        else setFilterText("")
        break;
      case 10:
        inputRef.current?.blur()
        setFilterOpen(filterOpen === 10 ? null : 10)
        if (filterOpen !== 10) handleInput(1, schoolViewFilter["percentage_worst" + schoolLeaderView])
        else setFilterWorst("")
        break;
      case 11:
        inputRef.current?.blur()
        setFilterOpen(filterOpen === 11 ? null : 11)
        if (filterOpen !== 11) handleInput(1, schoolViewFilter["percentage_best" + schoolLeaderView])
        else setFilterBest("")
        break;
    }
  }

  const getFilters = () => {
    let filters = []
    if (selectedSchoolViewSearch && (selectedSchoolViewSearch.type === "STUDENT" || selectedSchoolViewSearch.type === "COURSE")) {

    }
    else {
      if (schoolLeaderView !== 0 && schoolLeaderView !== 7) {
        filters.push(<FilterInput key={"filter_1"} width={"230px"}>
          <input placeholder={i18n.t("filter-name")} onChange={e => handleFilter(0, e.target.value)} value={schoolViewFilter["search" + schoolLeaderView] ?? ''} />
          <FilterReset onClick={e => clearFilter(0, '')} display={schoolViewFilter["search" + schoolLeaderView]?.length > 0} absolute={true} />
        </FilterInput>)
      }

      if (schoolLeaderView === 1 || schoolLeaderView === 2 || schoolLeaderView === 8 ) {
        filters.push(<FilterButton key={"filter_2"}>
          <FilterText onClick={() => showFilter(1)}>{i18n.t(schoolLeaderView === 3 ? (settings.SHOWPRESENCE ? "course-attendance-belov" : "course-absence-over") : schoolViewFilter.advanced? (settings.SHOWPRESENCE?"advance-current-filter-presence":"advance-current-filter"): schoolLeaderView === 8?(settings.SHOWPRESENCE ? "kohort-attendance-below" : "kohort-absence-over"): (settings.SHOWPRESENCE ? "attendance-belov" : "absence-over"))}: <b>{settings.SHOWPRESENCE && schoolViewFilter["percentage" + schoolLeaderView] === 0 ? 100 : schoolViewFilter["percentage" + schoolLeaderView]}%</b></FilterText>
          <FilterReset onClick={e => clearFilter(1, '')} display={schoolViewFilter?.["percentage" + schoolLeaderView] > 0} />
          <FilterDrop show={filterOpen === 1}>
            <FilterDropHead>{i18n.t(schoolViewFilter.advanced? (settings.SHOWPRESENCE?"advance-current-filter-presence":"advance-current-filter") : settings.SHOWPRESENCE ? "attendance-percentage" : "absence-percentage")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t(schoolViewFilter.advanced? "advance-current-tooltip": settings.SHOWPRESENCE ? "filter-tooltip-percentage-attendance" : "filter-tooltip-percentage")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <FilterItem>{i18n.t(schoolViewFilter.advanced? "advance-current-filter":settings.SHOWPRESENCE ? "attendance-percentage" : "absence-percentage")}<FilterDropInput ref={inputRef} type="number" width={"100%"} placeholder={""} onChange={e => handleInput(1, e.target.value)} value={filterText ?? ''} /> </FilterItem>
            <FilterButtons>
              <button onClick={() => handleApply(1)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 1 && schoolViewFilter.advanced) {
        filters.push(<FilterButton key={"filter_2_2"}>
          <FilterText onClick={() => showFilter(11)}>{i18n.t("advance-best")}: <b>{settings.SHOWPRESENCE && schoolViewFilter["percentage_best" + schoolLeaderView] === 0 ? 100 : schoolViewFilter["percentage_best" + schoolLeaderView]}%</b></FilterText>
          <FilterReset onClick={e => clearFilter(11, '')} display={schoolViewFilter?.["percentage_best" + schoolLeaderView] > 0} />
          <FilterDrop show={filterOpen === 11}>
            <FilterDropHead>{i18n.t(!settings.SHOWPRESENCE?"advance-best-filter":"advance-best-filter-presence")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t(!settings.SHOWPRESENCE?"advance-best-tooltip":"advance-best-tooltip-presence")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <FilterItem>{i18n.t(!settings.SHOWPRESENCE?"advance-best-filter":"advance-best-filter-presence")}<FilterDropInput ref={inputRef} type="number" width={"100%"} placeholder={""} onChange={e => handleInput(11, e.target.value)} value={filterBest ?? ''} /> </FilterItem>
            <FilterButtons>
              <button onClick={() => handleApply(11)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 3 || schoolLeaderView === 1) {
        filters.push(<FilterButton key={"filter_3"}>
          <FilterText onClick={() => { setFilterOpen(filterOpen === 2 ? null : 2); setCourseFilter('') }}>{i18n.t("filter-courses")}: <b>{getCourseFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(2, [])} display={schoolViewFilter["courses" + schoolLeaderView]?.length > 0} />
          <FilterDrop big={true} show={filterOpen === 2}>
            <FilterDropHead>{i18n.t("filter-courses")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-courses-tooltip-text") + (schoolLeaderView === 1 ? ("\n" + i18n.t("filter-courses-tooltip-text2", { count: 10 })) : "")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <FilterItem>{i18n.t("filter-courses-placeholder")}<FilterDropInput width={"100%"} placeholder={i18n.t('filter-courses-placeholder')} onChange={e => setCourseFilter(e.target.value)} value={courseFilter} /> </FilterItem>
            <FilterItem border={true} rowStack={true}><CheckBox onClick={() => handleInput(2, -1)} checked={courses.length === 0}><CheckboxIcon /></CheckBox>{i18n.t('all')}</FilterItem>
            <FilterContainer>
              {getCourses()?.filter(c => c.course_name.toLowerCase().includes(courseFilter?.toLowerCase())).map((c, index) => <FilterItem key={"course_filter_" + index} border={true} rowStack={true}><Tooltip content={schoolLeaderView === 1 && courses.length === 10 && !courses.includes(c.course_id) ? i18n.t("filter-courses-tooltip-text2", { count: 10 }) : ""}><CheckBox onClick={() => schoolLeaderView === 1 && courses.length === 10 && !courses.includes(c.course_id) ? null : handleInput(2, c.course_id)} checked={courses.includes(c.course_id)}><CheckboxIcon /></CheckBox></Tooltip> {c.course_name}</FilterItem>)}
            </FilterContainer>
            <FilterButtons>
              <button onClick={() => handleApply(2)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 1) {
        filters.push(<FilterButton key={"filter_9"}>
          <FilterText onClick={() => { setFilterOpen(filterOpen === 9 ? null : 9); setSubjectFilter('') }}>{i18n.t("filter-subjects")}: <b>{getSubjectFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(8, [])} display={schoolViewFilter["subjects" + schoolLeaderView]?.length > 0} />
          <FilterDrop big={true} show={filterOpen === 9}>
            <FilterDropHead>{i18n.t("filter-subjects")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-subjects-tooltip-text") + (schoolLeaderView === 1 ? ("\n" + i18n.t("filter-subjects-tooltip-text2", { count: 10 })) : "")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <FilterItem>{i18n.t("filter-subject-placeholder")}<FilterDropInput width={"100%"} placeholder={i18n.t('filter-subject-placeholder')} onChange={e => setSubjectFilter(e.target.value)} value={subjectFilter} /> </FilterItem>
            <FilterItem border={true} rowStack={true}><CheckBox onClick={() => handleInput(3, -1)} checked={subjects.length === 0}><CheckboxIcon /></CheckBox>{i18n.t('all')}</FilterItem>
            <FilterContainer>
              {getSubject()?.filter(s => s.subject_name.toLowerCase().includes(subjectFilter?.toLowerCase())).map((s, index) =>
                <FilterItem key={"subject_filter_" + index} border={true} rowStack={true}>
                  <Tooltip content={schoolLeaderView === 1 && subjects.length === 10 && !subjects.includes(s.course_id + "," + s.subject_name) ? i18n.t("filter-subjects-tooltip-text2", { count: 10 }) : ""}>
                    <CheckBox onClick={() => schoolLeaderView === 1 && subjects.length === 10 && !subjects.includes(s.course_id + "," + s.subject_name) ? null : handleInput(3, s.course_id + "," + s.subject_name)} checked={subjects.includes(s.course_id + "," + s.subject_name)}>
                      <CheckboxIcon />
                    </CheckBox>
                  </Tooltip>
                  {s.subject_name}
                </FilterItem>)}
            </FilterContainer>
            <FilterButtons>
              <button onClick={() => handleApply(8)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 1 && !schoolViewFilter.advanced) {
        filters.push(<FilterButton key={"filter_4"}>
          <FilterText onClick={() => setFilterOpen(filterOpen === 5 ? null : 5)}>{i18n.t(callNameSetting) + " " + i18n.t("status")}: <b>{getActiveFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(5, true)} display={!schoolViewFilter.active || !schoolViewFilter.inactive} />
          <FilterDrop show={filterOpen === 5}>
            <FilterDropHead>{i18n.t(callNameSetting) + " " + i18n.t("status")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-tooltip-active")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <FilterItem rowStack={true}>
              <CheckBox onClick={() => handleInput(5, active)} checked={active}><CheckboxIcon /></CheckBox>
              {i18n.t("active")}
            </FilterItem>
            <FilterItem rowStack={true}>
              <CheckBox onClick={() => handleInput(6, inactive)} checked={inactive}><CheckboxIcon /></CheckBox>
              {i18n.t("reward-inactive")}
            </FilterItem>
            <FilterButtons>
              <button onClick={() => handleApply(5)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 0 || schoolLeaderView === 4) {
        filters.push(<FilterButton key={"filter_5"}>
          <FilterText onClick={() => setFilterOpen(filterOpen === 3 ? null : 3)}>{i18n.t("date")}: <b>{getDateFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(3, null)} display={(schoolLeaderView !== 0 && schoolViewFilter["quickfilter" + schoolLeaderView] !== 5) || (schoolLeaderView === 0 && schoolViewFilter["quickfilter" + schoolLeaderView] !== 0)} />
          <FilterDrop big={true} show={filterOpen === 3}>
            <FilterDropHead>{i18n.t("filter-registratons-date")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-registrations-date-tooltip-text")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>

            <FilterItem rowStack={true}>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 0} onClick={() => handleDateQuickFilter(0, 3)}>{i18n.t("dash-select1")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 1} onClick={() => handleDateQuickFilter(1, 3)}>{i18n.t("filter-date-quickfilter-1")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 2} onClick={() => handleDateQuickFilter(2, 3)}>{i18n.t("filter-date-quickfilter-2")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 3} onClick={() => handleDateQuickFilter(3, 3)}>{i18n.t("filter-date-quickfilter-3")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 4} onClick={() => handleDateQuickFilter(4, 3)}>{i18n.t("filter-date-quickfilter-4")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 5} onClick={() => handleDateQuickFilter(5, 3)}>{i18n.t("filter-date-quickfilter-5")}</QuickBtn>
            </FilterItem>

            <hr />
            <FilterItem><h4>{i18n.t('registration-filter-custom')}</h4></FilterItem>
            <FilterItem rowStack={true}>
              <DateContainer>
                <SubTitle>{i18n.t('export-from')}</SubTitle>
                <DateSelect minDate={true} type={1} value={fromDate} setDate={handleDate}>
                  <DateSelector><span>{moment(fromDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
                </DateSelect>
              </DateContainer>

              <DateContainer>
                <SubTitle>{i18n.t('export-to')}</SubTitle>
                <DateSelect minDate={true} type={2} value={toDate} setDate={handleDate}>
                  <DateSelector><span>{moment(toDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
                </DateSelect>
              </DateContainer>
            </FilterItem>

            <FilterButtons>
              <button onClick={() => handleApply(3)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>


          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 3) {
        filters.push(<FilterButton key={"filter_6"}>
          <FilterText onClick={() => setFilterOpen(filterOpen === 7 ? null : 7)}>{i18n.t("days")}: <b>{getDayFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(7, null)} display={(schoolViewFilter["quickfilter" + schoolLeaderView] !== 3)} />
          <FilterDrop big={true} show={filterOpen === 7}>
            <FilterDropHead>{i18n.t("filter-registratons-date")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-registrations-date-tooltip-text")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>

            <FilterItem rowStack={true}>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 0} onClick={() => handleFilter(7, 1, 0)}>{i18n.t("filter-days-quickfilter-0")}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 1} onClick={() => handleFilter(7, 7, 1)}>{i18n.t("filter-days-quickfilter-1", { count: 7 })}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 2} onClick={() => handleFilter(7, 14, 2)}>{i18n.t("filter-days-quickfilter-1", { count: 14 })}</QuickBtn>
              <QuickBtn active={schoolViewFilter["quickfilter" + schoolLeaderView] === 3} onClick={() => handleFilter(7, 30, 3)}>{i18n.t("filter-days-quickfilter-1", { count: 30 })}</QuickBtn>
            </FilterItem>

            {/* <hr />
            <FilterItem><h4>{i18n.t('registration-filter-custom')}</h4></FilterItem>
            <FilterItem rowStack={true}>
              <DateContainer>
                <SubTitle>{i18n.t('export-from')}</SubTitle>
                <DateSelect minDate={true} type={1} value={fromDate} setDate={handleDate}>
                  <DateSelector><span>{(fromDate ? moment(fromDate) : moment()).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
                </DateSelect>
              </DateContainer>

              <DateContainer>
                <SubTitle>{i18n.t('export-to')}</SubTitle>
                <DateSelect minDate={true} type={2} value={toDate} setDate={handleDate}>
                  <DateSelector><span>{(toDate ? moment(toDate) : moment()).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
                </DateSelect>
              </DateContainer>
            </FilterItem>

            <FilterButtons>
              <button onClick={() => handleApply(3, -1)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons> */}
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 3) {
        filters.push(<FilterButton key={"filter_7"}>
          <FilterText onClick={() => setFilterOpen(filterOpen === 4 ? null : 4)}>{i18n.t("registered")}: <b>{getTypeFilterText()}</b></FilterText>
          <FilterReset onClick={e => clearFilter(4, [])} display={schoolViewFilter.types.length > 0} />
          <FilterDrop show={filterOpen === 4}>
            <FilterDropHead>{i18n.t("registration-type")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("registration-type-tooltip-text")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>

            <FilterItem onClick={() => handleInput(4, -1)} border={true} rowStack={true}><CheckBox checked={types.length === 0}><CheckboxIcon /></CheckBox>{i18n.t('all')}</FilterItem>
            <FilterItem onClick={() => handleInput(4, 1)} border={true} rowStack={true}><CheckBox checked={types.includes(1)}><CheckboxIcon /></CheckBox>{i18n.t('registration-type-present')}</FilterItem>
            <FilterItem onClick={() => handleInput(4, 3)} border={true} rowStack={true}><CheckBox checked={types.includes(3)}><CheckboxIcon /></CheckBox>{i18n.t('registration-type-late')}</FilterItem>
            <FilterItem onClick={() => handleInput(4, 2)} border={true} rowStack={true}><CheckBox checked={types.includes(2)}><CheckboxIcon /></CheckBox>{i18n.t('registration-type-absence')}</FilterItem>

            <FilterButtons>
              <button onClick={() => handleApply(4)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if (schoolLeaderView === 4) {
        filters.push(<FilterButton key={"filter_8"}>
          <FilterText onClick={() => setFilterOpen(filterOpen === 6 ? null : 6)}>{i18n.t("filter-tag-text1")}: <b>{schoolViewFilter.tags.length === 0 ? i18n.t("all") : schoolViewFilter.tags.length + " " + i18n.t("selected")}</b></FilterText>
          <FilterReset onClick={e => clearFilter(6, [])} display={schoolViewFilter?.tags.length > 0} />
          <FilterDrop show={filterOpen === 6}>
            <FilterDropHead>{i18n.t("filter-tag-text1")}</FilterDropHead>
            <FilterInfo>
              <Tooltip content={i18n.t("filter-tooltip-tags")}>
                <Tooltip_Icon />
              </Tooltip>
            </FilterInfo>
            <span>{i18n.t("filter-tag-text2")}:</span>
            <FilterItem>
              <GapScroll>
                {selectedTags.length === 0 ? i18n.t("all") : schoolViewTags?.map((t, i) => selectedTags.includes(t.tag_id) ? <Tag key={"t_" + i} onClick={() => handleTags(t.tag_id)} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag> : null)}
              </GapScroll>
            </FilterItem>
            <span>{i18n.t("header-tags")}:</span>
            <FilterItem>
              <GapScroll>

                {schoolViewTags?.map((t, i) => !selectedTags.includes(t.tag_id) ? <Tag key={"t_" + i} onClick={() => handleTags(t.tag_id)} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag> : null)}
              </GapScroll>
            </FilterItem>
            <FilterButtons>
              <button onClick={() => handleApply(6)}>{i18n.t("filter-apply")}</button>
              <button onClick={() => setFilterOpen(null)}>{i18n.t("close")}</button>
            </FilterButtons>
          </FilterDrop>
        </FilterButton>)
      }

      if(schoolLeaderView === 1){
         filters.push(<div key={"filter_10"} style={{display:"flex", gap:"10px", alignItems:"center"}}>
          <CheckBox onClick={() => handleApply(9)} checked={schoolViewFilter.advanced}><Check_Icon /></CheckBox>
          <span style={{fontSize:"14px"}}>{i18n.t('advanced-view')}</span>
        </div>)
      }

      if (schoolLeaderView !== 0) {
        filters.push(<ExportDropDown key={"filter_11"} onClick={() => setFilterOpen(filterOpen === 8 ? null : 8)}>
          <span>{i18n.t('export-statistik')}<Chevron_Icon /></span>

          <ExportContent open={filterOpen === 8}>
            <span onClick={props.exportExcel}><Excel_Icon />{i18n.t('export-selected')}</span>
          </ExportContent>
        </ExportDropDown>)
      }
      
    }
    

    return filters
  }

  useEffect(() => {
    if (filterOpen === 1) {
      inputRef.current?.focus()
      inputRef.current.type = "text"
      inputRef.current.setSelectionRange(-1, -1)
      inputRef.current.type = "number"
    }
  }, [filterOpen])

  useEffect(() => {
    setFilterOpen(null)
    switch (schoolLeaderView) {
      case 0:
        setFromDate(schoolViewFilter.fromDate0)
        setToDate(schoolViewFilter.toDate0)
        break;
      case 1:

        setCourses(schoolViewFilter.courses1)
        break;
      case 2:

        break;
      case 3:
        setCourses(schoolViewFilter.courses3)
        setFromDate(schoolViewFilter.fromDate3 ? moment(schoolViewFilter.fromDate3).toDate() : moment().toDate())
        setToDate(schoolViewFilter.toDate3 ? moment(schoolViewFilter.toDate3).toDate() : moment().toDate())
        break;
      case 4:
        setFromDate(schoolViewFilter.fromDate4 ? moment(schoolViewFilter.fromDate4).toDate() : moment().toDate())
        setToDate(schoolViewFilter.toDate4 ? moment(schoolViewFilter.toDate4).toDate() : moment().toDate())
        break;
    }
  }, [schoolLeaderView])

  const filters = props.filterSelected ? getFilters() : [];

  return (<>
    <FilterBar display={filters.length > 0}>
      <FilterBox>
        {filters}
      </FilterBox>
    </FilterBar>
  </>);
};

export default SubNav;
